// extracted by mini-css-extract-plugin
module.exports = {"root":"WebhookInfo_root__61KKL","title":"WebhookInfo_title__3vJLH","text":"WebhookInfo_text__1u_7W","link":"WebhookInfo_link__3SVoR"};